import React from 'react';
import createSvgIcon from '../../../shared/utils/create-svg-icon';
import { ReactComponent as Icon } from '../../../assets/icon-skyscraper.svg';

export const SkyscraperIcon = createSvgIcon(<Icon />, 'SkyscraperIcon');
